import * as actionTypes from "../actions/actionTypes";

const initState = {
    loadingDealer: false,
    dealer: null,
    error: null,
    //Dealer Posts :
    dealerPosts: null
};

export const initGetDealer = (state, action) => {
    return {
        ...state,
        loadingDealer: action.loadingDealer
    }
};
export const successGetDealer = (state, action) => {
    return {
        ...state,
        loadingDealer: action.loadingDealer,
        dealer: action.dealer.data,
    }
};
export const failGetDealer = (state, action) => {
    return {
        ...state,
        loadingDealer: action.loadingDealer,
        error: action.error,
    }
};

//###################### Dealer Posts :

export const GetDealerPosts = (state, action) => {
    return {
        ...state,
        loadingDealer: action.loadingDealer
    }
};
export const successGetDealerPosts = (state, action) => {
    return {
        ...state,
        loadingDealer: action.loadingDealer,
        dealerPosts: action.dealerPosts
    }
};
export const failGetDealerPosts = (state, action) => {
    return {
        ...state,
        loadingDealer: action.loadingDealer,
        error: action.error,
    }
};

const Reducer = (state = initState, action) => {
    switch (action.type) {
        case actionTypes.INIT_GET_DEALER: return initGetDealer(state, action);
        case actionTypes.SUCCESS_GET_DEALER: return successGetDealer(state, action);
        case actionTypes.FAIL_GET_DEALER: return failGetDealer(state, action);
        //Dealer Posts : 
        case actionTypes.INIT_GET_DEALER_POSTS: return GetDealerPosts(state, action);
        case actionTypes.SUCCESS_GET_DEALER_POSTS: return successGetDealerPosts(state, action);
        case actionTypes.FAIL_GET_DEALER_POSTS: return failGetDealerPosts(state, action);
        default: return { ...state };
    }
};

export default Reducer;